module.exports = __webpack_public_path__ + "static/media/FINAL_BASKET_LID_DESIGN0123456.47b9873c.jpg";